export const ProjectStatusOptions = [
    { value: 'PLANNED', label: 'Planned' },
    { value: 'INITIATED', label: 'Initiated' },
    { value: 'IN_PROGRESS', label: 'In Progress' },
    { value: 'ON_HOLD', label: 'On Hold' },
    { value: 'UNDER_REVIEW', label: 'Under Review' },
    { value: 'COMPLETED', label: 'Completed' },
    { value: 'TERMINATED', label: 'Terminated' },
    { value: 'CANCELLED', label: 'Cancelled' },
  ];

 export const PROJECT_CONSTANTS= {
    PLANNED: 'PLANNED',
    INITIATED: 'INITIATED',
    IN_PROGRESS: 'IN_PROGRESS',
    ON_HOLD: 'ON_HOLD',
    UNDER_REVIEW: 'UNDER_REVIEW',
    COMPLETED: 'COMPLETED',
    TERMINATED: 'TERMINATED',
    CANCELLED: 'CANCELLED',
  };
